import { render } from "./FormFakturPajakMasukan.vue?vue&type=template&id=bfd23316&scoped=true"
import script from "./FormFakturPajakMasukan.vue?vue&type=script&lang=js"
export * from "./FormFakturPajakMasukan.vue?vue&type=script&lang=js"

import "./FormFakturPajakMasukan.vue?vue&type=style&index=0&id=bfd23316&scoped=true&lang=css"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd23316"]])

export default __exports__